import { APIFactory } from '../../ui-toolkit/rest/APIFactory';
import { ICreateAchAccountResponse } from '../../types/accounting/response/ICreateAchAccountResponse';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import { ICreateAchAccount } from 'types/order/escrow/achDisbursements/ICreateACHAccount';
import { eAccountType } from 'types/order/escrow/IAchAccountData';
import { axiosErrorHandler } from '../../ui-toolkit/rest/axiosErrorHandler';

export interface ICreateAchAccountData {
  id?: string;
  accountType: eAccountType;
  name: string;
  accountNumber: string;
  routingNumber: string;
  ownerId?: string;
}

//POST Escrow ACH accounts
export const createAchAccountAsync = async ({
  accountType,
  name,
  accountNumber,
  routingNumber,
  ownerId,
}: ICreateAchAccountData): Promise<ICreateAchAccountResponse> => {
  const request: ICreateAchAccount = {
    type: accountType,
    name,
    accountNumber,
    routingNumber,
    ownerId,
  };
  return await APIFactory(baseUrlService.ApiLocation)
    .post<ICreateAchAccountResponse>(`/timber/api/internal/escrow/ach_accounts`, request)
    .then((response) => response.data)
    .catch(axiosErrorHandler);
};
